import React from "react";

const PaymentDetails = props => {
  // Card expiration gets removed from the state once the request comes back,
  // save it to a local variable so the app doesn't bomb
  let cardExpiration = props.CardExpiration || [];
  let paymentDetails = () => {
    if (props.paymentType === "debit" || props.paymentType === "Appraisal") {
      return `${props.CardType} ${props.CardNumberLastFour}`;
    } else {
      return `Account ending in ${props.CardNumberLastFour}`;
    }
  };
  return (
    <div className="payment-details">
      <h3>Payment Details</h3>
      <button onClick={props.goBackToPayments}>Change</button>
      <div className="payment-row" id="name-on-card">
        {props.NameOnCard}
      </div>
      <div className="payment-row" id="card-type-last-four">
        {paymentDetails()}
      </div>
    </div>
  );
};

export default PaymentDetails;



// WEBPACK FOOTER //
// ./src/components/payment-details/payment-details.component.js